export const colors = {
  background: '#283C75',
  text: '#FFF',
  highlight: '#B5DCF0',
};

export const trimmedText = { textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic' };

export const footerStyles = {
  bgcolor: colors.background,
  color: colors.text,
  px: { xs: 3, sm: 6, lg: 12 },
  pt: { xs: 4, lg: 7 },
  pb: { xs: 3, lg: 5 },
};

export const columnsStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(4, minmax(0, 1fr))',
  },
  gap: { xs: 3, sm: 4, lg: '37.5px' },
};

export const navigationTextStyles = {
  ...trimmedText,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.2,
  color: colors.text,
  minHeight: 24,
  pb: 1,
  display: 'block',
};

export const bottomStyles = {
  borderTop: `1px solid ${colors.text}`,
  pt: 3,
  display: 'flex',
  flexDirection: { xs: 'column', lg: 'row' },
  alignItems: { xs: 'flex-start', lg: 'center' },
  justifyContent: 'space-between',
  gap: { xs: 2.5, lg: 4 },
};

export const logosStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: 1,
  rowGap: 2,
  maxWidth: { xs: 268, lg: 'none' },
  flexShrink: 0,
};

export const appButtonStyles = {
  width: { xs: '100%', lg: '220.38px' },
  maxWidth: '100%',
  height: 40,
  p: 2,
  borderRadius: '4px',
  bgcolor: colors.highlight,
  color: colors.background,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.4,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { bgcolor: colors.highlight, boxShadow: 'none' },
};
